var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'infinite')?_c('div',{ref:"infiniteScroll",staticClass:"d-flex align-items-center justify-center p-4",attrs:{"data-cy":"infiniteScroll"}}):_c('b-pagination',_vm._b({on:{"input":function($event){return _vm.$emit('input', $event)}}},'b-pagination',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }